<div uiDragAndDropFile
     [fileBrowseRef]="specificBrowseTrigger"
     [fileClearRef]="specificClearTrigger"
     [multiple]="false"
     (fileChange)="onFileChange($event)"
     (fileClear)="onClear()"
     fileType=".json"
     [attr.data-cy]="'queue-' + schemaName + '-schema-upload-container'">
    <div class="layout-row">
        <input [value]="fileName"
               matInput
               readonly
               [attr.data-cy]="'queue-' + schemaName + '-file-name-input'" />
        <div #specificClearTrigger>
            <button *ngIf="currentValue"
                    [disabled]="reading$ | async"
                    type="button"
                    mat-icon-button
                    type="button"
                    [attr.data-cy]="'queue-' + schemaName + '-clear-file-button'">
                <mat-icon>cancel</mat-icon>
            </button>
        </div>
        <label #specificBrowseTrigger>
            <button [hidden]="currentValue"
                    [progressButtonLoading]="reading$ | async"
                    (click)="confirmUploadDialog($event)"
                    type="button"
                    progressButtonMode="indeterminate"
                    ui-progress-button
                    mat-button
                    class="ui-upload-button"
                    color="primary"
                    type="button"
                    [attr.data-cy]="'queue-' + schemaName + '-data-schema-upload'">
                <mat-icon>folder</mat-icon>
                <span translate
                      class="text-upper">
                    modal_action_browse
                </span>
            </button>
        </label>
        <label>
            <button [hidden]="!currentValue"
               (click)="onDownload()"
               type="button"
               mat-button
               class="ui-upload-button"
               color="primary">
                <mat-icon>file_download</mat-icon>
                <span translate
                      class="text-upper">
                    modal_action_download
                </span>
            </button>
        </label>
    </div>
</div>
